import { render, staticRenderFns } from "./NewProposal.vue?vue&type=template&id=45533316&"
import script from "./NewProposal.vue?vue&type=script&lang=js&"
export * from "./NewProposal.vue?vue&type=script&lang=js&"
import style0 from "./NewProposal.vue?vue&type=style&index=0&id=45533316&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports